<template>
  <div class="my_vote_list1">
    <!-- 头部开始 -->
    <topPart :rightPart="true">
      <template slot="difinePort">
        <div class="btn-block">
          <div class="rule-box" @click="enterRule">
            <img class="hospital-icon" src="../../../assets/images/hospital_icon.png" />
            <span class="hospital-rule">制度</span>
          </div>
        </div>
      </template>
    </topPart>
    <!-- 头部结束 -->
    <!-- 列表 -->
    <div class="list-block my-content" v-infinite-scroll="loadMore" infinite-scroll-distance="50">
      <!-- 循环列表 -->
      <div
        class="card-box"
        v-for="(item,index) in arrList"
        :key="index"
        @click="detailsOfSympathy(item)"
      >
        <!-- title栏 -->
        <div class="item-title">
          <!--类型  -->
          <div :class="'titleStyle ' + getTitileClass(item.type)">{{getTitleType(item.type)}}</div>
          <!-- 类型结束 -->
          <!-- 标题 -->
          <div class="nameStyle">{{item.title}}</div>
          <!-- 标题结束 -->
        </div>
        <!-- 内容 -->
        <div class="conterStyle" v-html="item.content"></div>
        <van-divider />
        <!-- 内容结束 -->
        <!-- 状态按钮 -->
        <div class="stateStyle">
          <span :class="getStatusColor(item)">{{getStatus(item)}}</span>
        </div>
        <!-- 状态按钮 -->
        <!-- title栏结束 -->
      </div>
      <!-- 循环列表结束 -->
    </div>
    <!-- 列表结束 -->
  </div>
</template>

<script>
import topPart from "../../../components/topPart";
export default {
  props: ["sendType", "system"], //第一种方式
  components: {
    topPart
  },
  created() {
    //this.getMemberList();
  },
  methods: {
    //制度事件
    enterRule() {
      this.$router.push({
        path: "/secondedDetailsRule",
        query: {
          backEndObj: JSON.stringify({ type: this.system }), //慰问类型,
          backEndInterface: "integralSystem" //后端接口
        }
      });
    },
    detailsOfSympathy(obj) {
      var router = this.typeConfig[obj.type].router;
      this.$router.push({
        path: router,
        query: {
          id: obj.recordId, //慰问类型
          type: obj.type, //类型
          voteId: obj.id,
          subStatusp: obj.subStatusp
        }
      });
    },
    //获取状态
    getStatus(item) {
      var str_1 = this.statusConfig[item.subStatusp].title;
      var str_2 = this.typeConfig[item.type].status;
      return str_1 + str_2;
    },
    //下拉刷新
    loadMore() {
      this.currentPage = this.currentPage + 1;
      this.getMemberList();
    },
    //列表后置处理
    getMemberListFun(data, message) {
      if (this.currentPage == 1) {
        this.arrList = [];
      }
      var arr = [...this.arrList, ...data.list];
      //列表赋值
      this.arrList = arr;
    },
    //获取参数
    getMemberListData() {
      var obj = {
        sendType: this.sendType, //会员代表2  //职工代表1
        currentPage: this.currentPage, //第几页
        pageSize: this.pageSize //每页展示数量
      };
      return obj;
    },
    //获取会员列表
    getMemberList() {
      var obj = this.getMemberListData();
      this.sendQuestion("wechatRepreList", obj, "getMemberListFun");
    },
    //后端发送请求函数
    sendQuestion(url, obj, fun) {
      this.centralControl.axios.centralControl(
        url,
        res => {
          const { message, code, data } = res;
          //请求返回 关闭加载页
          this.loading = false;
          if (code == 200) {
            this[fun](data, message);
          } else {
            console.log(res, "接口错误-");
          }
        },
        obj
      );
    },
    getTitleType(type) {
      return this.typeConfig[type].title;
    },
    getTitileClass(type) {
      return this.typeConfig[type].style;
    },
    getStatusColor(item) {
      return this.statusConfig[item.subStatusp].style;
    }
  },
  data() {
    return {
      statusConfig: {
        "0": { title: "去", style: "no_submit" },
        "1": { title: "已", style: "yes_submit" }
      },
      typeConfig: {
        vote: {
          title: "表决",
          status: "表决",
          router: "/voteDetails",
          style: "vote_color"
        },
        suggest: {
          title: "征求意见",
          status: "提交",
          router: "/suggestDetails",
          style: "suggest_color"
        }
      }, //类型配置
      arrList: [], //列表总数
      currentPage: 0, //第几页
      pageSize: 10 //每页个数
    };
  }
};
</script>

<style lang="stylus" type="stylesheet/stylus">
.hospital-icon {
  width: 17px;
}

.hospital-rule {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
}

.btn-block {
  margin: auto 10px;
  flex: 2;
  display: flex;
  justify-content: flex-end;

  .btn {
    border: none;
    background: rgba(56, 199, 196, 1);
    border-radius: 8px;
    color: #fff;
    font-size: 14px;
    width: 55px;
    height: 28px;
  }
}

.my_vote_list1 {
  .item-title {
    display: flex;
    align-items: center;
  }

  .card-box {
    position: relative;
    padding: 0;
    border-bottom: 1px solid #F4F4F7;
    margin-bottom: 10px;
    padding: 16px;
  }

  .nameStyle {
    width: 0 !important;
    margin-left: 8px;
    display: inline-block;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
    flex: 1;
    min-width: 0;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 22px;
  }

  .conterStyle {
    margin: 10px auto 10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(136, 136, 136, 1);

    >p {
      line-height: 20px;
      font-size: 14px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    > ol, span, ol, li, ul, h1, h2, strong, em {
      display: inline-block;
    }

    > img, br {
      display: none;
    }
  }

  .stateStyle {
    display: flex;
    flex-direction: row-reverse;
  }

  .titleStyle {
    padding: 4px 7px;
    border-radius: 20px;
    font-size: 11px;
    color: #fff;
    text-align: center;
    display: inline-block;
    // margin: auto 10px auto 0;
    background: linear-gradient(103deg, rgba(79, 172, 254, 1), rgba(0, 242, 254, 1));
  }

  .list-block {
    overflow: scroll;
  }

  .suggest_color {
    background: linear-gradient(103deg, rgba(69, 209, 172, 1), rgba(39, 189, 186, 1));
  }

  .vote_color {
    background: linear-gradient(103deg, rgba(255, 19, 86, 1), rgba(255, 59, 142, 1), rgba(255, 19, 86, 1));
  }

  .no_submit {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(255, 75, 75, 1);
  }

  .yes_submit {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(41, 190, 188, 1);
  }
}
</style>